import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../../config';
import Pagination from '../../Pagination/Paginations';
import EntriesSelector from '../../Pagination/EntriesSelector';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
});

const Position = (props) => {

  const { fixNavbar } = props;

  /* ================= STATES ================= */
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    positions: '',
    is_active: 1,
  });
  const [editData, setEditData] = useState({
    position_id: '',
    positions: '',
    is_active: 1,
  });

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchPositions();
  }, []);

  const fetchPositions = () => {
    axios.get(API_BASE_URL + '/position_list', authHeaders())
    .then(res => {
      setTableData(res.data.data.positions || []);
    })
    .catch(() => toast.error('Failed to load position list'));
  };

  /* ================= ADD ================= */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!formData.positions.trim()) {
      toast.error('Kindly Enter Position!!!');
      return;
    }
    setSubmitting(true);

    axios.post(API_BASE_URL + '/add_position', formData, authHeaders())
    .then(res => {
      toast.success(res.data.message);
      setFormData({ positions: '', is_active: 1 });
      fetchPositions();
    })
    .catch(err => toast.error(err.response?.data?.message || 'Failed to add position'))
    .finally(() => setSubmitting(false));
  };

  /* ================= UPDATE ================= */
  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/update_position', editData, authHeaders())
    .then(res => {
      toast.success(res.data.message);
      setTimeout(() => window.location.reload(), 1500);
    })
    .catch(err => toast.error(err.response?.data?.message || 'Failed to update position'));
  };

  /* ================= SEARCH ================= */
  const filteredData = tableData.filter(item =>
    item.positions?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  /* ================= DATATABLE STYLES ================= */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: '#f8f9fa',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
    rows: {
      style: {
        minHeight: '42px',
      },
    },
  };

  /* ================= COLUMNS ================= */
  const columns = [
    {
      name: 'Position',
      selector: row => row.positions,
      sortable: true,
    },
    {
      name: 'Status',
      cell: row => (
        <span className={`badge ${Number(row.is_active) === 1 ? 'badge-success' : 'badge-secondary'}`}>
          {Number(row.is_active) === 1 ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      name: 'Created By',
      selector: row => row.created_by_name,
    },
    {
      name: 'Created Date',
      selector: row => row.created_date,
      sortable: true,
    },
    {
      name: 'Action',
      width: '100px',
      cell: row => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#editPositionModal"
          onClick={() => setEditData({
            position_id: row.position_id,
            positions: row.positions,
            is_active: Number(row.is_active),
          })}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];

  return (
    <>
      <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">

          {/* ================= ADD POSITION ================= */}
          <div className="card mb-4">
            <div className="card-body">
              <h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-id-badge mr-2" style={{ fontSize: "20px" }} />
                Add Position
              </h3>

              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <label>Position Name </label>
                    <input
                      type="text"
                      className="form-control required-input"
                      placeholder="Position"
                      maxLength={100}
                      value={formData.positions}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          positions: e.target.value.replace(/[^A-Za-z0-9 .\-\/&()]/g, ''),
                        })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Status </label>
                    <select
                      className="form-control"
                      value={formData.is_active}
                      onChange={e =>
                        setFormData({ ...formData, is_active: Number(e.target.value) })
                      }
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <button className="btn btn-primary btn-sm" disabled={submitting}>
                      {submitting ? "Saving..." : "Add"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* ================= POSITION LIST ================= */}
          <div className="card">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-id-badge mr-2" style={{ fontSize: "20px" }} />
                Position List
              </h3>

              <div className="ml-auto">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <EntriesSelector
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    setCurrentPage={setCurrentPage}
                  />
                  <div style={{ marginLeft: '15px' }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      style={{ width: '220px' }}
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <DataTable
                columns={columns}
                data={currentData}
                dense
                striped
                highlightOnHover
                responsive
                persistTableHead
                fixedHeader
                fixedHeaderScrollHeight="400px"
                customStyles={customStyles}
              />

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>

        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      <div className="modal fade" id="editPositionModal">
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Position</h5>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>

              <div className="modal-body">
                <label>Position Name</label>
                <input
                  type="text"
                  className="form-control required-input mb-3"
                  maxLength={100}
                  value={editData.positions || ''}
                  onChange={e =>
                    setEditData({ ...editData, positions: e.target.value.replace(/[^A-Za-z0-9 .\-\/&()]/g, '') })
                  }
                  required
                />

                <label>Status</label>
                <select
                  className="form-control"
                  value={editData.is_active}
                  onChange={e =>
                    setEditData({ ...editData, is_active: Number(e.target.value) })
                  }
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps)(Position);
